var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-radio",class:[_vm.checked && 'data-radio_checked', _vm.disabled && 'disabled'],on:{"click":_vm.toggleCheck}},[_c('div',{staticClass:"data-radio__icon",class:[_vm.checked && !_vm.disabled ? 'data-radio__icon_show' : '', _vm.disabled && 'disabled']})])
}
var staticRenderFns = []

export { render, staticRenderFns }